// api.ts
import axios from 'axios';
import { Company, AuthResponse, User } from '../types';

// Création d'une instance d'axios avec l'URL du backend définie dans la variable d'environnement
const api = axios.create({
  baseURL: import.meta.env.VITE_API, // Utilisation de la variable d'environnement
  withCredentials:true
  // headers: {
  //   'Content-Type': 'application/json',
  // }
});

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API des entreprises
export const companyApi = {
  register: async (data: Partial<Company>): Promise<Company> => {
    const response = await api.post<Company>('/companies/register', data);
    return response.data;
  },
};

// API d'authentification
export const authApi = {
  login: async (email: string, password: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', { email, password });
    // Stockage du token dans le localStorage
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },
  
  verifyCode: async (email: string, code: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/verify-code', { email, code });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },
  
  changePassword: async (email: string, newPassword: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/change-password', { 
      email, 
      newPassword 
    });
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
  }
};

// API des utilisateurs
export const userApi = {
  createUser: async (userData: Partial<User>): Promise<User> => {
    const response = await api.post<User>('/users', userData);
    return response.data;
  },
  
  updateUser: async (id: string, userData: Partial<User>): Promise<User> => {
    const response = await api.put<User>(`/users/${id}`, userData);
    return response.data;
  },
  
  getUsers: async (companyId: string): Promise<User[]> => {
    const response = await api.get<User[]>(`/users/company/${companyId}`);
    return response.data;
  },
};

// Gestionnaire d'erreur global
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Déconnexion automatique si le token est invalide
      authApi.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);